import {characteristicMultiple} from "@/helper/application/Populate";

const CHARACTERISTIC_MULTIPLE = {
	'functions': {
		metaItemsProperty: 'function',
		metaTypeProperty: 'functionType',
	},
	'functionMarketingRole': {
		metaItemsProperty: 'functionMarketingRole',
		metaTypeProperty: 'functionMarketingRoleType',
	},
	'functionLegalField': {
		metaItemsProperty: 'functionLegalField',
		metaTypeProperty: 'functionLegalFieldType',
	},
	'functionLegalRole': {
		metaItemsProperty: 'functionLegalRole',
		metaTypeProperty: 'functionLegalRoleType',
	},
	'functionTaxField': {
		metaItemsProperty: 'functionTaxField',
		metaTypeProperty: 'functionTaxFieldType',
	},
	'functionTaxRole': {
		metaItemsProperty: 'functionTaxRole',
		metaTypeProperty: 'functionTaxRoleType',
	},
	'careerLevels': {
		metaItemsProperty: 'careerLevel',
		metaTypeProperty: 'careerLevelType',
	},
	'industrialSectors': {
		metaItemsProperty: 'industrialSector',
		metaTypeProperty: 'industrialSectorType',
	},
	'organisationalArea': {
		metaItemsProperty: 'organisationalArea',
		metaTypeProperty: 'organisationalAreaType',
	},
	'geo': {
		metaItemsProperty: 'geo',
		metaTypeProperty: 'geoType',
	},
	'companySize': {
		metaItemsProperty: 'companySize',
		metaTypeProperty: 'companySizeType',
	},
	'companyType': {
		metaItemsProperty: 'companyType',
		metaTypeProperty: 'companyTypeType',
	},
};

export function populate ({job, meta})
{
	_.forOwn(job, (value, key) =>
	{
		const characteristicMultipleConfig = CHARACTERISTIC_MULTIPLE[key];

		if (characteristicMultipleConfig)
		{
			job[key] = characteristicMultiple(
				value,
				meta,
				meta[characteristicMultipleConfig.metaItemsProperty],
				meta[characteristicMultipleConfig.metaTypeProperty],
				true
			);
		}

		if (key === 'relocation' && value?.geo)
		{
			job[key].geo = characteristicMultiple(
				value.geo,
				meta,
				meta.geo,
				meta.geoType,
				true
			);
		}
	});

	return job;
}
